import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  section: 'data-section-type="main-blog"',
}
const qsAll = {
  tags: 'data-article-tag',
}

export const setupBlog = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    dom.tags.forEach((tag) => {
      tag.addEventListener('input', (e) => {
        const tagValue = tag.value
        if (tag.checked) {
          location.href = `${dom.section.dataset.blogUrl}/tagged/${tagValue}`
          dom.tags.forEach((t) => {
            if (t.value != tagValue) t.checked = false
          })
        } else location.href = dom.section.dataset.blogUrl
      })
    })
  }
}
